import axios from "axios";
import {BASE_URL} from "@/constant";

const url = `${BASE_URL}/api`;
const jwtConfig = () => ({
    headers: {
        Authorization: "Bearer " + localStorage.getItem('jwt'),
    },
});
export default {
    save(category) {
        return axios.post(`${url}/category`, category, jwtConfig());
    },
    update(category) {
        return axios.put(`${url}/category`, category, jwtConfig());
    },
    delete(category) {
        return axios.delete(`${url}/category/${category.id}`, jwtConfig());
    },
    getAll(pageable, criteria) {
        let resUrl = pageable
            ? `?page=${pageable.page}&size=${pageable.size}&sort=${pageable.sortBy},${pageable.sort}`
            : "-list";
        if (criteria != null) {
            resUrl += criteria.name ? `&name=${criteria.name}` : "";
        }
        return axios.get(`${url}/user/category${resUrl}`);
    },
    getOne(id) {
        return axios.get(`${url}/user/category/${id}`);
    },
};
